import { render } from "./linkRank.vue?vue&type=template&id=019fd462&scoped=true"
import script from "./linkRank.vue?vue&type=script&lang=js"
export * from "./linkRank.vue?vue&type=script&lang=js"

import "./linkRank.vue?vue&type=style&index=0&id=019fd462&scoped=true&lang=css"
import "./linkRank.vue?vue&type=style&index=1&id=019fd462&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019fd462"]])

export default __exports__